import React, { useState, useEffect } from "react";
import "./styles.scss";
import { GetIconByName } from "../../../config/icon";

/* property description goes here

  type= {text or password}
  placeholder = { string - isRequired }
  isConfig={true or false}
  icanName={string - isRequired}
  label={string - isRequired}
  size={sma or lg}
  value={string - isRequired}
  statusName={string - isRequired}
  smallProp={true or false}
  isCount={true or false}
  count={number}
  maxCount={number}
  isShowRequired={true or false}
  rightType={password , rightCount)}
*/

const Index = ({ data, onChange }) => {
  let inputElement = null;
  inputElement = (
    <>
      <form autoComplete="off">
        <textarea
          className={`txtarea-wrapper ${data.size} ${data.rightType} 
          ${data.smallProp && " tws__pro"}`}
          {...data.elementConfig}
          value={data.value}
          onChange={onChange}
        />
      </form>

      {data.isRightCount && (
        <>
          <div className={"taw__count"}>
            {data && data.value && data.value.length}/
            {data.elementConfig.maxCount}
          </div>
        </>
      )}
      {data.iconName && (
        <>
          <div className={"taw__icon"}>{GetIconByName(data.iconName)}</div>
        </>
      )}
    </>
  );
  return (
    <>
      <div className={"main-txtarea-wrapper"}>
        {data.label && (
          <div className="d-flex flex-row">
            <label className="txtarea-label">
              {data.label} {data.isShowRequired ? <b>*</b> : ""}
            </label>
            {GetIconByName(data.lblIcon)}
          </div>
        )}
        <div>{inputElement}</div>

        {/*---- error goes here -----*/}
        {data &&
          data.validation &&
          data.validation.required &&
          data.touched && (
            <>
              {/*---- filed is required -----*/}
              {data.validation.required && !data.value && (
                <div className="taw__statusCode">
                  You can't keep this as empty
                </div>
              )}

              {/*---- number is required -----*/}
              {data.value && data.validation.number && !data.isValid && (
                <div className="taw__statusCode">
                  This filed required only numbers.
                </div>
              )}
            </>
          )}
      </div>
    </>
  );
};
export default Index;
